import SimpleButton from '../objects/simpleButton';

export default class Title extends Phaser.Scene {
  /**
   *  My custom scene.
   *
   *  @extends Phaser.Scene
   */
  constructor() {
    super({
      key: 'Title'
    });
  }

  /**
   *  Called when this scene is initialized.
   *
   *  @protected
   *  @param {object} [data={}] - Initialization parameters.
   */
  init(/* data */) { }

  /**
   *  Used to declare game assets to be loaded using the loader plugin API.
   *
   *  @protected
   */
  preload() { }

  /**
   *  Responsible for setting up game objects on the screen.
   *
   *  @protected
   *  @param {object} [data={}] - Initialization parameters.
   */
  create(/* data */) {
    const x = this.cameras.main.width;
    const y = this.cameras.main.height;
    this.titleImages = [];
    this.titleConfig = this.cache.json.get('data').titleConfig;
    let titleImagesLength = this.titleConfig.images.length;
    for (var i = 0; i < titleImagesLength; i++) {
      let sX = this.titleConfig.images[i].x;
      let sY = this.titleConfig.images[i].y;
      let scale = this.titleConfig.images[i].scale;
      let sprite = this.add.sprite(sX, sY, this.titleConfig.images[i].name);
      sprite.scaleX = scale;
      sprite.scaleY = scale;
      this.titleImages.push(sprite);
    }

    let logo = this.titleImages[this.titleImages.length - 1];
    let scX = logo.scaleX;
    let scY = logo.scaleY;
    logo.scaleX = 0;
    logo.scaleY = 0;
    this.tweens.add({
      targets: logo,
      scaleX: scX,
      scaleY: scY,
      easeParams: [0.9, 0.25],
      duration: 900,
      delay: 100,
      ease: 'Elastic.easeOut'
    });

    /*     let playBtn = this.add.sprite(x / 2, y - 120, 'startBtn');
    playBtn
      .setInteractive({
        useHandCursor: true
      })
      .on('pointerdown', () => this.handlePlayButtonDown()); */

    let playBtn = new SimpleButton(this, x / 2, y - 120, 'startBtn', () =>
      this.handlePlayButtonDown()
    );
    playBtn.alpha = 0;
    this.tweens.add({
      targets: playBtn,
      alpha: 1,
      duration: 500,
      delay: 1000,
      ease: 'Quad.easeOut'
    });

    // this.cache.getBitmapFont(this.titleConfig.title.font).font.lineHeight = 5;
    // let title = this.add.bitmapText(
    //   x / 2,
    //   20 + y / 2,
    //   this.titleConfig.title.font,
    //   this.titleConfig.title.text
    // );
    // title.setFontSize(this.titleConfig.title.size);
    let localisation = this.cache.json.get('localisation');

    let title = this.add.text(x/2, 20+y/2, localisation["game_title"][window.language].text, {fontFamily: localisation["game_title"][window.language].font});
    title.setFontSize(Number.parseFloat(localisation["game_title"][window.language].size));
    title.setPadding(0,20,0,20);
    title.setAlign('center');
    title.setOrigin(0.5);
  }

  handlePlayButtonDown() {

    this.scene.start('CharacterSelect');
  }

  /**
   *  Handles updates to game logic, physics and game objects.
   *
   *  @protected
   *  @param {number} t - Current internal clock time.
   *  @param {number} dt - Time elapsed since last update.
   */
  update(/* t, dt */) { }

  /**
   *  Called after a scene is rendered. Handles rendenring post processing.
   *
   *  @protected
   */
  render() { }

  /**
   *  Called when a scene is about to shut down.
   *
   *  @protected
   */
  shutdown() { }

  /**
   *  Called when a scene is about to be destroyed (i.e.: removed from scene
   *  manager). All allocated resources that need clean up should be freed up
   *  here.
   *
   *  @protected
   */
  destroy() {
    this.titleImages.destroy();
    this.titleImages = null;
    super.destroy();
  }
}
